// extracted by mini-css-extract-plugin
export var downArrow = "_8z-0";
export var label = "_8z-1";
export var treatmentCard = "_8z-3";
export var upArrow = "_8z-2";